export enum OpportunitiesEvents {
  OPPORTUNITIES_VIEWED = "opportunities_viewed",
  OPPORTUNITY_CLICKED = "opportunities_opportunity_clicked",
  OPPORTUNITY_ACCEPTED = "opportunities_opportunity_accepted",
  OPPORTUNITY_DISMISSED = "opportunities_opportunity_dismissed",
  TRAINING_STARTED = "opportunities_training_started",
  TRAINING_COMPLETED = "opportunities_training_completed",
  TRAINING_CENTER_VIEWED = "opportunities_training_center_viewed",
  OPPORTUNITY_VIEWED = "opportunities_opportunity_viewed",
  AI_INSTANCE_DELETED = "opportunities_ai_instance_deleted",
  SKILL_PRACTICED = "opportunities_skill_practiced",
}